import { classNameList } from 'utils/property';
import { capitalize } from 'utils/string';
import styles from './Spinner.module.scss';

interface IProps {
  size?: 'small' | 'medium' | 'large';
  fill?: string;
  ariaLabel?: string;
  className?: string;
}

export const Spinner = ({ size = 'medium', fill = '#101820', ariaLabel, className }: IProps) => {
  return (
    <>
      <svg
        version="1.1"
        id="L9"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        enableBackground="new 0 0 0 0"
        xmlSpace="preserve"
        viewBox="0 0 24 24"
        className={classNameList(styles.spinner, styles[`spinner${capitalize(size)}`], className)}>
        <path
          d="M11,.9c0-.5-.5-.9-1-.8-2.6.4-5.1,1.7-6.9,3.7C1.2,6.1,0,8.9,0,11.9s1.1,5.9,3.1,8.1c2,2.2,4.7,3.6,7.7,3.9s5.9-.5,8.3-2.3,4.1-4.4,4.6-7.3c.6-2.9,0-6-1.5-8.5-1.4-2.3-3.5-4.1-6-5-.5-.2-1,0-1.1.6-.1.5.1,1,.6,1.2,2.1.8,3.8,2.3,5,4.2,1.3,2.2,1.8,4.8,1.3,7.2-.5,2.5-1.9,4.7-3.9,6.2s-4.6,2.2-7.1,2c-2.5-.3-4.9-1.4-6.6-3.3-1.7-1.9-2.6-4.3-2.6-6.9s1-5,2.7-6.8c1.5-1.6,3.5-2.7,5.7-3.1.5,0,.9-.5.8-1v-.2Z"
          fill={fill}></path>
      </svg>
      <span className="visually-hidden">{ariaLabel}</span>
    </>
  );
};
